import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "src/@services/common.service";
import { FormService } from "src/@services/form.service";
import { InnerPagesService } from "src/app/pages/common-layout/inner-pages.service";
import data from "src/assets/states.json";
import { Vendor } from "src/models/vendor.model";
import { BrowserPlatformService } from "src/@services/browser-platform.service";
@Component({
  selector: "app-edit-vendor-details",
  templateUrl: "./edit-vendor-details.component.html",
  styleUrls: ["./edit-vendor-details.component.scss"],
  standalone: false,
})
export class EditVendorDetailsComponent implements OnInit {
  //#region properties
  isVisibleEditVendor: boolean = true;
  @Output() hideEditVendorModal = new EventEmitter();
  @Input() currentVendorData: Vendor;
  isaddLinesClicked: boolean = false;
  isUpdatingVendor: boolean = false;
  siteId: string;
  listOfStates = data.States;
  uploadedFile: any = {};
  //#endregion

  //constrctor
  constructor(
    public _fS: FormService,
    public _cS: CommonService,
    private route: ActivatedRoute,
    private _iS: InnerPagesService,
    private browserPlatformService: BrowserPlatformService
  ) {
    _fS.addVendorForm_fb();
  }

  //#region functions
  ngOnInit(): void {
    this.siteId = this.route.snapshot.paramMap.get("siteId");
    this.listOfStates = data.States;
  }
  handleCancel(event: any) {
    this.isVisibleEditVendor = false;
    this.hideEditVendorModal.emit(event ? event : null);
    this.uploadedFile = {};
  }

  openDocView() {
    this.currentVendorData.w9AttachmentURL &&
    this.currentVendorData.w9AttachmentName === this.uploadedFile?.name
      ? this.browserPlatformService.openInNewTab(this.currentVendorData.w9AttachmentURL)
      : event?.preventDefault;
  }

  //#endregion
}
